// Bejerman master-table code→label lists for the "Enviar a ERP" create-customer
// form (§8.3). These are near-static install/config data (VEC's Bejerman), so
// they're hardcoded here rather than fetched live from the gateway — pull them
// again and edit this file the rare time a code changes.
//
// Sources (2026-09-14):
//   - situacionIva:      Bejerman "Estructura de Datos" doc (ARCA enum, Cliente_SitIVA)
//   - provincia/condVenta/situacionIibb/situacionGanancias: PO export from Bejerman
//
// The `code` is exactly what Bejerman expects (the value sent on create-cliente
// and on the comprobante). Numeric codes are zero-padded 3-digit for condVenta /
// provincia; the situación codes are single-digit strings.

export interface CatalogoOption {
  code: string;
  label: string;
}

// Cliente_SitIVA (Estructura de Datos doc). Default for VEC customers: "1".
export const SITUACION_IVA_OPTIONS: CatalogoOption[] = [
  { code: '1', label: 'Inscripto' },
  { code: '2', label: 'No Inscripto' },
  { code: '3', label: 'Consumidor Final' },
  { code: '4', label: 'No Responsable' },
  { code: '5', label: 'Exento' },
  { code: '6', label: 'Responsable Monotributo' },
  { code: '7', label: 'Sujeto No Categorizado' },
];

// Cliente_SituacionIIBBCodigo.
export const SITUACION_IIBB_OPTIONS: CatalogoOption[] = [
  { code: '1', label: 'Inscripto jurisdicción local' },
  { code: '2', label: 'Inscripto convenio multilateral' },
  { code: '3', label: 'No inscripto' },
  { code: '4', label: 'No alcanzado' },
  { code: '5', label: 'Exento' },
  { code: '6', label: 'Consumidor Final' },
  { code: '9', label: 'Reg. Simplificado' },
];

// Cliente_SituacionGananciasCodigo.
export const SITUACION_GANANCIAS_OPTIONS: CatalogoOption[] = [
  { code: '1', label: 'Inscripto' },
  { code: '2', label: 'No Inscripto' },
  { code: '3', label: 'No alcanzado' },
  { code: '4', label: 'Exento' },
];

// Cliente_CodigoProvincia (ordered by code).
export const PROVINCIA_OPTIONS: CatalogoOption[] = [
  { code: '001', label: 'Capital Federal' },
  { code: '002', label: 'Buenos Aires' },
  { code: '003', label: 'Catamarca' },
  { code: '004', label: 'Córdoba' },
  { code: '005', label: 'Corrientes' },
  { code: '006', label: 'Chaco' },
  { code: '007', label: 'Chubut' },
  { code: '008', label: 'Entre Ríos' },
  { code: '009', label: 'Formosa' },
  { code: '010', label: 'Jujuy' },
  { code: '011', label: 'La Pampa' },
  { code: '012', label: 'La Rioja' },
  { code: '013', label: 'Mendoza' },
  { code: '014', label: 'Misiones' },
  { code: '015', label: 'Neuquén' },
  { code: '016', label: 'Río Negro' },
  { code: '017', label: 'Salta' },
  { code: '018', label: 'San Juan' },
  { code: '019', label: 'San Luis' },
  { code: '020', label: 'Santa Cruz' },
  { code: '021', label: 'Santa Fe' },
  { code: '022', label: 'Santiago del Estero' },
  { code: '023', label: 'Tierra del Fuego' },
  { code: '024', label: 'Tucumán' },
  { code: '025', label: 'EXTERIOR' },
];

// Cliente_CondicionVentaCodigo is NOT a rep choice (PO 2026-09-14): always send
// "010" (Contado). The full condición-de-venta table is intentionally not listed
// here — it isn't a form dropdown. Recover it from git history if that changes.
export const CONDICION_VENTA_DEFAULT = '010';
